export default class DepartmentModel {
    id: number = 0
}


// WEBPACK FOOTER //
// ./ClientApp/src/models/DepartmentModel.ts